export enum AnalyticsEvent {
  Click = 'Click',
  OpenUrl = 'OpenUrl',
  OpenModal = 'OpenModal'
}
